<template>
    <div
        class="w-full h-auto relative flex flex-col gap-y-16 p-12 justify-center items-center"
    >
        <!-- HEADER -->
        <section class="flex-col justify-start items-center gap-3 flex">
            <h1
                class="text-black text-4xl font-semibold leading-10 text-center"
            >
                Hotel award booking, made easy.
            </h1>
            <p
                class="text-black text-opacity-50 text-base font-normal leading-normal text-center"
            >
                You've earned the rewards - now let them take you to amazing
                places!
            </p>
        </section>
        <!-- SEARCH FORM -->
        <section class="w-5/6 relative">
            <SearchTabs
                :tabs="tabs"
                :activeTab="activeTab"
                @changeActiveTab="setActiveTab"
                class="mb-6"
            />
            <HotelDropdown v-if="activeTab === 'Specific Hotel'" />
            <SearchForm v-if="activeTab === 'Date availability'" />
            <!-- CIRCLE BACKGROUND GRAPHIC -->
            <div
                class="absolute w-[275.53px] h-[275.53px] -inset-y-6 -end-32 circles -z-10"
            >
                <div
                    class="w-[204.09px] h-[204.09px] left-[27.70px] top-[19.23px] absolute rounded-full shadow border border-orange-400"
                ></div>
                <div
                    class="w-[249.91px] h-[249.91px] left-[4.79px] top-[-3.68px] absolute rounded-full shadow border border-orange-400"
                ></div>
                <div
                    class="w-[160.36px] h-[160.36px] left-[49.56px] top-[41.09px] absolute rounded-full shadow border border-orange-400"
                ></div>
                <div
                    class="w-[116.62px] h-[116.62px] left-[71.43px] top-[62.96px] absolute rounded-full shadow border border-orange-400"
                ></div>
            </div>
        </section>

        <!-- START HOTEL BRANDS SECTION -->
        <section class="w-full">
            <HotelBrandsBand />
        </section>
        <!-- START FAVORITES SECTION -->
        <section class="favorites-carousel w-full max-w-6xl">
            <!-- <FavoritesWidget title="Favorites" /> -->
        </section>
        <!-- START ALERTS SECTION -->
        <section class="alerts-carousel w-full max-w-6xl">
            <AlertsWidget title="Alerts" />
        </section>
        <!-- FEATURED HOTEL SEARCH -->
        <section class="w-full max-w-6xl">
            <FeaturedHotelSearch />
        </section>
    </div>
</template>
<script>
import { mapState, mapActions } from 'pinia';
import { useHotelsStore } from '@/store/hotels';
import { useAlertsStore } from '@/store/alerts';
import { useCalendarStore } from '@/store/calendar';

import SearchTabs from '@/components/ui/search-tabs/tabs.vue';
import SearchForm from '@/components/hotels/search/search-form/search-form.vue';
import HotelDropdown from '@/components/hotels/search/search-form/hotel-dropdown.vue';
import HotelBrandsBand from '@/components/hotels/hotel-brands/hotel-brands-band.vue';
import AlertsWidget from '@/components/alerts/alerts-widget/alerts-widget.vue';
import FavoritesWidget from '@/components/hotels/favorites/favorites-widget/favorites-widget.vue';
import FeaturedHotelSearch from '@/components/hotels/search/featured-hotel-search/featured-hotel-search.vue';

export default {
    components: {
        HotelBrandsBand,
        AlertsWidget,
        FavoritesWidget,
        SearchForm,
        HotelDropdown,
        SearchTabs,
        FeaturedHotelSearch,
    },
    data: () => ({
        activeTab: 'Date availability',
        tabs: ['Date availability', 'Specific Hotel'],
    }),
    computed: {
        ...mapState(useHotelsStore, ['loading', 'searchQuery']),
        ...mapState(useCalendarStore, ['checkIn', 'checkOut']),
        disabledNextPage() {
            return (
                this.loading || this.searchResults.meta.last_page === this.page
            );
        },
        disabledPrevPage() {
            return this.loading || this.searchResults.meta.current_page === 1;
        },
    },
    methods: {
        ...mapActions(useHotelsStore, [
            'search',
            'getAllGroups',
            'clearParams',
        ]),
        ...mapActions(useAlertsStore, ['clearFilters']),
        setActiveTab(tab) {
            this.activeTab = tab;
        },
    },
    mounted() {
        this.getAllGroups();
        this.clearParams();
        this.clearFilters();
    },
};
</script>
<style lang="scss" scoped>
.circles {
    opacity: 0.3;
    mask-image: linear-gradient(to right, transparent, black);
}
</style>
<!-- #F8954D, #F1F5F9 -->
